import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetOfficialPlannedPlantationHeadersInputDto, ImportOfficialPlannedPlantationHeadersInputDto, OfficialPlannedPlantationHeaderCreateDto, OfficialPlannedPlantationHeaderDto, OfficialPlannedPlantationHeaderExcelDownloadDto, OfficialPlannedPlantationHeaderUpdateDto } from '../dtos/official-planned-plantation-header/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OfficialPlannedPlantationHeaderService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: OfficialPlannedPlantationHeaderCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationHeaderDto>({
      method: 'POST',
      url: '/api/operational/officialPlannedPlantationHeaders',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/officialPlannedPlantationHeaders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/officialPlannedPlantationHeaders',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationHeaderDto>({
      method: 'GET',
      url: `/api/operational/officialPlannedPlantationHeaders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationHeaders/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOfficialPlannedPlantationHeadersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OfficialPlannedPlantationHeaderDto>>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationHeaders',
      params: { periodId: input.periodId, vendorId: input.vendorId, propertyLocationId: input.propertyLocationId, signatureReasonId: input.signatureReasonId, dinamaReasonId: input.dinamaReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: OfficialPlannedPlantationHeaderExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/officialPlannedPlantationHeaders/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, periodId: input.periodId, vendorId: input.vendorId, propertyLocationId: input.propertyLocationId, signatureReasonId: input.signatureReasonId, dinamaReasonId: input.dinamaReasonId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationHeaderDto[]>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationHeaders/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  import = (input: ImportOfficialPlannedPlantationHeadersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationHeaderDto[]>({
      method: 'POST',
      url: '/api/operational/officialPlannedPlantationHeaders/import',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: OfficialPlannedPlantationHeaderUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationHeaderDto>({
      method: 'PUT',
      url: `/api/operational/officialPlannedPlantationHeaders/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}